import React from 'react'
import {connect} from 'react-redux'
import TabContent from '../../components/Operations/TabContent'
import { receiveOperationsData } from '../../actions/statusesActions'

const mapStateToProps = (state) => {
  return {
    operationsData: state.adminStatuses.operations
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveOperationsData: (data) => {
      dispatch(receiveOperationsData(data))
    }
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(TabContent)


// WEBPACK FOOTER //
// ./src/admin/statuses/javascripts/containers/Operations/TabContentContainer.jsx